import React from "react";
import { FormattedMessage } from "react-intl";
import {
  Grid,
  GridItem,
  Text,
  HStack,
  VStack,
  StackDivider,
  Button,
} from "@chakra-ui/react";
import { MethodClassIcon } from "components/Icons";
import BankMoreOptionsMenu from "./BankMoreOptionsMenu";

const BankName = ({ name }) => {
  return <Text fontSize="xs">{name}</Text>;
};

const BankAccount = ({
  bankAccount,
  onUpdate,
  isSelected,
  disabled,
  onBankAccountClick,
  linkedPaymentMethods = [],
  ...props
}) => {
  return (
    <Grid
      p="4"
      borderWidth="1px"
      borderRadius="4px"
      gap="2"
      templateColumns="1fr 11fr"
      onClick={() => onBankAccountClick(bankAccount)}
      bgColor={isSelected ? "lightBackground" : "background"}
      borderColor={isSelected && "integrator.300"}
      opacity={disabled ? 0.5 : 1}
      pointerEvents={disabled ? "none" : "all"}
      boxShadow="base"
      cursor="pointer"
      data-testid={`bank-account-${bankAccount.bank_account_id}`}
      {...props}
    >
      <GridItem>
        <MethodClassIcon name={bankAccount.institution_name} />
      </GridItem>
      <GridItem gridColumn="2/-1">
        <HStack justify="space-between">
          <BankName name={bankAccount.display_string} />
          <BankMoreOptionsMenu
            bankAccount={bankAccount}
            onComplete={onUpdate}
            disableDelete={linkedPaymentMethods.length > 0}
            disableDeleteTooltipMessage="Delete linked payment methods first"
          />
        </HStack>
      </GridItem>
      <GridItem gridColumn="2/-1">
        <HStack align="start" divider={<StackDivider />}>
          <Text color="secondaryText" fontSize="xs" textAlign="right">
            <FormattedMessage
              defaultMessage="Linked payout {lineBreak} methods"
              description="Label text.  Ignore the 'lineBreak', should read as just 'linked payout methods'"
              values={{ lineBreak: <br /> }}
            />
          </Text>
          <VStack
            flex="1"
            align="start"
            p="2"
            divider={<StackDivider />}
          >
            {linkedPaymentMethods.length === 0 && (
              <Text color="secondaryText" fontSize="xs">
                <FormattedMessage
                  defaultMessage="None"
                  description="Label text"
                />
              </Text>
            )}
            {linkedPaymentMethods.length > 0 &&
              linkedPaymentMethods.map((pm) => (
                <Text key={`linked-pm-${pm.id}`} color="secondaryText" fontSize="xs">
                  {pm.display_string}
                </Text>
              ))}
          </VStack>
        </HStack>
      </GridItem>
      <GridItem gridColumn="1/-1">
        <Button size="xs" variant="link">
          <FormattedMessage
            defaultMessage="Add payout method to this bank account..."
            description="Label text"
          />
        </Button>
      </GridItem>
    </Grid>
  );
};

export default BankAccount;
